import React, { useMemo, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { compose } from 'redux';
import preLoader from '@om-fe/core/core/bootstrap/preload';
import withTranslation from '@om-fe/core/core/i18n/with-translation';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import withRouting from '@om-fe/core/core/routing/with-routing';
import { EMRoutingContextInterface } from '@om-fe/core/core/routing/utils';
import { DisciplineLiveStatus } from '@om-fe/models';
import getConfig, { OMFE2ConfigModel, BannerMatrixConfig } from '@om-fe/core/utils/config';
import { Breakpoints } from '@om-fe/core/core/store/breakpoints';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import { getVirtualStateExtraParams, setVirtualStateExtraParams } from '@om-fe/core/core/routing/custom-routes/custom-routes.utils';
import { TopBetsStorageData } from '../utils/top-bets.utils';
import { DEFAULT_DISPLAYED_NUMBER_OF_MATCHES } from '../../match-list/utils/match-list.constants';
import TopBetsMatchListSelector from '../containers/top-bets-list/top-bets-list-selector';
export interface TopBetsContentPublicProps {
    readonly instanceId: string;
    readonly breakpoints: Breakpoints;
    readonly disciplineId: string;
    readonly locationId?: string;
    readonly categoryId?: string;
    readonly isCategory?: boolean;
    readonly isTopBets?: boolean;
    readonly mainMarketsLimit?: number;
}
interface TopBetsStoreProps {
    readonly isAuthenForTopic?: boolean;
}

type TopBetsMatchListProps = TopBetsContentPublicProps
    & TopBetsStoreProps
    & I18nContextInterface
    & EMRoutingContextInterface;

const config: OMFE2ConfigModel = getConfig();
const bannerMatrixConfig: BannerMatrixConfig | undefined = config.bannerMatrix;
const enabledTopicDelay: boolean | undefined = config.enabledTopicDelay;

function TopBetsContentComponent(
    {
        instanceId,
        disciplineId,
        isCategory,
        deviceType,
        isTopBets,
        locationId,
        categoryId,
        mainMarketsLimit,
        isAuthenForTopic,
    }: TopBetsMatchListProps,
) {
    useEffect(() => {
        const storage: TopBetsStorageData = getVirtualStateExtraParams<TopBetsStorageData>();
        setVirtualStateExtraParams({ sportId: storage?.sportId ? storage.sportId : disciplineId });
    }, []);

    const matchListLayout = config.matchListConfig?.commonConfig?.matchListItemLayout;
    const eventsNumber: number = config.matchListConfig?.commonConfig?.eventsNumber ?? DEFAULT_DISPLAYED_NUMBER_OF_MATCHES;
    const marketSelector: boolean = config?.matchListConfig?.matchListSelector?.enabled ?? false;
    const marketGroupsOverviewNumber: number | undefined = config?.matchListConfig?.matchListSelector?.numberOfList;
    const showMarketSelectorHeader: boolean = config.matchListConfig?.matchListSelector?.showHeader ?? true;

    const renderContent = useMemo(() => {
        return (
            <TopBetsMatchListSelector
                itemLayout={matchListLayout}
                disciplineId={disciplineId}
                instanceId={`${instanceId}-Match-List`}
                limitNumberOfEvents={eventsNumber}
                liveStatus={DisciplineLiveStatus.LIVE}
                mainMarketsLimit={mainMarketsLimit}
                marketGroupsOverviewNumber={marketGroupsOverviewNumber}
                hasMarketSelector={marketSelector}
                showMatchListHeader={false}
                showMarketInMatchListGroupHeader={true}
                deviceType={deviceType}
                showMarketSelectorHeader={showMarketSelectorHeader}
                isTopBets={isTopBets}
                locationId={isCategory ? undefined : locationId}
                categoryId={isCategory ? categoryId : undefined}
                isCategory={isCategory}
                isAuthenForTopic={isAuthenForTopic}
            />
        );
    }, [isTopBets, locationId, categoryId, mainMarketsLimit, disciplineId]);

    return (
        <>
            {renderContent}
        </>
    );
}

const SportAllLocationContent: React.ComponentType<TopBetsContentPublicProps> = compose<React.ComponentType<TopBetsContentPublicProps>>(
    withRouting(),
    withTranslation<TopBetsContentPublicProps>(),
    connect<TopBetsStoreProps, {}, TopBetsContentPublicProps>(
        (state: AppState, props: TopBetsContentPublicProps): TopBetsStoreProps => {

            const isAuthenForTopic: boolean = !!(enabledTopicDelay && state.session?.info?.isAuthenticated);

            return {
                isAuthenForTopic,
            };
        },
    ),
)(TopBetsContentComponent);
export default SportAllLocationContent;
